var UltraLight = 200;
var Regular = 400;
var Medium = 500;
var Semibold = 600;
var Bold = 700;
var Tablet = 768;
var MqTablet = "(min-width: ".concat(Tablet, "px)");
var Desktop = 1200;
var MqDesktop = "(min-width: ".concat(Desktop, "px)");
var Mono = "'IBM Plex Mono', 'Menlo', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', Courier, monospace";
var Sans = "'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif";
export { Bold, Desktop, Medium, Mono, MqDesktop, MqTablet, Regular, Sans, Semibold, Tablet, UltraLight };